import {combineReducers} from 'redux';
import system from './system';
import content from './content';
import header from './header';
import footer from './footer';
import theme from './theme';

/**
 * Connect reducers to the redux store.
 */

/* istanbul ignore next */
const reducers = combineReducers({
    system,
    content,
    header,
    footer,
    theme,
});

export default reducers;
